// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__27nx7","title":"Divider_title__VWtaO"};